import kebabCase from 'lodash/kebabCase';
import { useQuery } from 'react-query';

import {
  NEWSLETTER_SUBSCRIPTIONS_KEY,
  Newsletter,
  NewsletterSubscription,
  getNewsletterSubscriptions,
} from '@utils/backend-api/newsletters';

const buildNewsletter = (newsletters?: Newsletter[]): NewsletterSubscription[] => {
  if (!newsletters) return undefined;
  return newsletters.map((newsletter) => ({
    accessLevel: newsletter.accessLevel,
    author: newsletter.author,
    frequency: newsletter.frequency,
    isPro: newsletter.isProOnly,
    isSubscribed: newsletter.currentUserSubscribed,
    newsletterId: newsletter.id,
    offerCode: newsletter.offerCode,
    slug: kebabCase(newsletter.name),
    subheader: newsletter.description,
    title: newsletter.name,
  }));
};

export default function useNewsletterSubscriptions() {
  const { data, isLoading: isLoadingNewsletterSubscriptions } = useQuery<Newsletter[]>(
    NEWSLETTER_SUBSCRIPTIONS_KEY,
    () => getNewsletterSubscriptions()
  );

  return { newsletters: buildNewsletter(data), isLoadingNewsletterSubscriptions };
}
